import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import  Slider  from 'react-slick';
import conversations from '../misc/categoryLandingConversations';
import categoryLandingNewsTaglines from '../misc/categoryLandingNewsTaglines';
import Image from '../components/Image';


export class CategoryBannerSlider extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let sliderSettings = {};
    let slides = [];
    let coverSize = '';
    const { collection, browser } = this.props;

    if(collection.items.length == 0) {
      return <span />;
    }

    if(browser.width < 1200) {
      let h = Math.round(browser.width * (315/851));
      coverSize = `${browser.width}x${h}`;

      if(browser.lessThan.tablet) {
        let h = Math.round(browser.width/100 * 75);
        coverSize = `${browser.width - 16}x${h}`;
      }
    } else {
      coverSize = '1200x367';
    }

    slides = collection.items.map(item => {
      let coverImageSrc = '';
      if(browser.lessThan.tablet) {
        coverImageSrc = `thumbnails/?model=organization&id=${item.id}&size=${coverSize}&source=image_cover_small`;
      } else {
        coverImageSrc = `thumbnails/?model=organization&id=${item.id}&size=${coverSize}&source=image_cover`;
      }



      let iconImageSrc = `thumbnails/?model=organization&id=${item.id}&size=75x75&source=image_icon`;

      return <div key={item.id}>
        <div className="categoryDetail-bannerSlider-innerWrapper">
          <Link to={`/organizations/${item.id}`}>
            <Image className="organizationCard-coverImage" src={coverImageSrc} />
            <div className="name-icon-container">
              <div className="item-name">{item.name}</div>
              <img src={item.image_icon} alt={item.name} className="image-icon" />
            </div>
          </Link>
        </div>
      </div>;
    });

    return <div className="categoryDetail-bannerSlider">
      <Slider>{slides}</Slider>
      </div>;

  }
}


export class CategoryConversationSlider extends Component {
  render() {

    let newsTagline = '';
    if (categoryLandingNewsTaglines[this.props.slug]) {
      newsTagline = categoryLandingNewsTaglines[this.props.slug];
    }

    const collection = conversations[this.props.slug];
    const { categoryName, browser } = this.props;
    let slides = [];

    if(!collection) {
      return <h4 style={{margin: 0, padding: 0}}>&nbsp;</h4>;
    }

    slides = collection.map((item, idx) => {
      return <div key={`slide-${idx}`}>
        <a className="item-anchor" target="_blank" rel="noopener" href={item.url}>
          <img src={item.image} alt={`${item.title} - ${item.description}`} className="item-image" />
          <div className="item-title-description-container">
            <div className="item-title">{item.title}</div>
            <div className="item-description">{item.description}</div>
            <div className="item-via">Via {item.via}</div>
          </div>
        </a>
      </div>;
    });

    if(slides.length == 0) {
    }

    let settings = {
      autoplay: false,
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    if(browser.greaterThan.phablet) {
      settings.slidesToShow = 2;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tablet) {
      settings.slidesToShow = 3;
      settings.slidesToScroll = 3;
    }



    return <div className="categoryDetail-conversationSlider">
      <h4>{categoryName}: What's new?</h4>
      <p>{newsTagline.tagline}</p>
      <Slider { ...settings }>{slides}</Slider>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/CategoryPageSliders.jsx